import { useContext, useEffect, useState } from "react";
import { CustomThemeContext } from "../../ThemeContext";
import Toggle from "./Switch";
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';

//Icons
import HomeIcon from '@mui/icons-material/Home';
import LibraryBooksIcon from '@mui/icons-material/LibraryBooks';
import LoginIcon from '@mui/icons-material/Login';
import HowToRegIcon from '@mui/icons-material/HowToReg';
import InfoIcon from '@mui/icons-material/Info';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
  
export default function Sidebar(props){
    
    const {Mode, User, ChangeSelect} = useContext(CustomThemeContext);
    const [menu, changeMenu] = useState(false);
    
    useEffect(()=>{
        var elm = document.querySelector('ul').childNodes;
        for(let i=0;i<elm.length;i++){
            if( i === props.Select){
                elm[i].childNodes[0].classList.remove('line-dark');
                elm[i].childNodes[0].classList.remove('text-white');
                elm[i].childNodes[0].classList.add('active');
            }
            else if(Mode === 'Dark'){
                elm[i].childNodes[0].classList.remove('active');
                elm[i].childNodes[0].classList.remove('line-dark');
                elm[i].childNodes[0].classList.add('text-white');
            }
            else{
                elm[i].childNodes[0].classList.remove('active');
                elm[i].childNodes[0].classList.remove('text-white');
                elm[i].childNodes[0].classList.add('link-dark');
            }
        }

        if(Mode === 'Dark'){
            //For sidebar menus
            document.getElementById('sidebar').classList.remove('bg-light');
            document.getElementById('sidebar').classList.add('text-white');
            document.getElementById('sidebar').classList.add('bg-dark');

            //For bottom part
            var usr = document.getElementById('dropdownUser1'),
            logo = document.getElementById('logo');

            if(usr && logo){
                usr.classList.add('text-white');
                usr.classList.remove('link-dark');

                //For popup menu
                logo.classList.remove('dropdown-menu-light');
                logo.classList.add('dropdown-menu-dark');
            }
        }else{
            //For sidebar menus
            document.getElementById('sidebar').classList.remove('text-white');
            document.getElementById('sidebar').classList.remove('bg-dark');
            document.getElementById('sidebar').classList.add('bg-light');

            var usr = document.getElementById('dropdownUser1'),
            logo = document.getElementById('logo');

            //For bottom part
            if(usr && logo){
                usr.classList.remove('text-white');
                usr.classList.add('link-dark');

                //For popup menu
                logo.classList.add('dropdown-menu-light');
                logo.classList.remove('dropdown-menu-dark');
            }
        }
        
        document.getElementById("about").addEventListener('click',()=>{
            ChangeSelect(elm.length-1);
        });

        document.getElementById("hometag").addEventListener('click',()=>{
            ChangeSelect(0);
        });

        function changeBlogTheme(){
            var blogs = document.getElementById("blogs");
            if(blogs){
                if(Mode === 'Dark'){
                    document.body.style.backgroundColor = window.dark;
                    document.body.style.color = window.light;
                }else{
                    document.body.style.backgroundColor = window.light;
                    document.body.style.color = window.dark;
                }
            }
            
        }
        changeBlogTheme();
    });

    function ToggleMenuClose(){
        document.getElementById("sidebar").style.width = "0px";
        document.getElementById("sidebar").classList.remove('p-3');
        document.getElementById("navbtn").style.marginLeft = "25px";
        changeMenu(false);
    }

    function ToggleMenuOpen(){
        document.getElementById("sidebar").style.width = "300px";
        document.getElementById("sidebar").classList.add('p-3');
        document.getElementById("navbtn").style.marginLeft = "325px";
        changeMenu(true);
    }

    return(
            <>
                <div id="sidebar" className="d-flex flex-column flex-shrink-0 text-white">
                    <a className="d-flex align-items-center mb-3 mb-md-0 me-md-auto text-decoration-none">
                        <span className="fs-4"><font color="red"><strong>Django Blogs</strong></font></span>
                        <Toggle/>
                    </a>
                <hr/>
                <ul className="nav nav-pills flex-column mb-auto">
                    <li className="nav-item">
                    <a href="#home" className="nav-link" aria-current="page" id="hometag">
                        <HomeIcon/> Home
                    </a>
                    </li>
                    {User.logged?<li>
                    <a href="/create/blogs" target="_blank" className="nav-link">
                        <LibraryBooksIcon/> Your Blogs
                    </a>
                    </li>:null}
                    {!User.logged?<><li>
                    <a href="/accounts/signup" target="_blank" className="nav-link">
                        <HowToRegIcon/> Sign Up
                    </a>
                    </li>
                    <li>
                    <a href="/accounts/login" target="_blank" className="nav-link">
                        <LoginIcon/> Sign In
                    </a>
                    </li></>:null}
                    <li>
                    <a href="#foot" className="nav-link" id="about">
                        <InfoIcon/> About
                    </a>
                    </li>
                </ul>
                <hr/>
                {User.logged?<div className="dropdown">
                    <a href="#" className="d-flex align-items-center text-decoration-none dropdown-toggle" id="dropdownUser1" data-bs-toggle="dropdown" aria-expanded="false">
                        <Avatar src={User.image} style={{marginRight: "10px"}}/>
                        <strong id="user_name">{window.UNAME}</strong>
                    </a>
                    <ul className="dropdown-menu text-small shadow" aria-labelledby="dropdownUser1" id="logo">
                        <li><a className="dropdown-item" href="/create" target="_blank" >New Blog</a></li>
                        <li><a className="dropdown-item" href={"/accounts/profile/?uname="+window.UNAME} target="_blank" >Profile</a></li>
                        <li><hr className="dropdown-divider"/></li>
                        <li><a className="dropdown-item" href="/accounts/logout" >Sign out</a></li>
                    </ul>
                </div>:null}  
                </div>
                <Button variant="contained" style={{zIndex: 105, position: "fixed", marginLeft: "25px", marginTop: "20px", width: "fit-content", transition: "0.4s"}} 
                color="error" size="small" onClick={menu?ToggleMenuClose:ToggleMenuOpen} id="navbtn">
                    {!menu?<MenuIcon/>:<CloseIcon/>}
                </Button>
            </>
    );
}